import React, {useEffect} from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "./pages/routes";

function App() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const domain = params.get('domain');
    if (domain) {
      localStorage.setItem('domain', domain);
    }
  }, []);

  return <RouterProvider router={router} />;
}

export default App;
